import React from "react";

export default (props) => (
    <div className='container-loading'>
      <div className="image"><a href="https://www.corrivium.com" target="_blank" rel="noopener noreferrer"><img src="corrivium.png" alt='Corrivium Live' /></a></div>
      <h3>{props.message}</h3>
    </div>
  );